import { render, staticRenderFns } from "./Elevator.vue?vue&type=template&id=3b417c20&scoped=true&"
import script from "./Elevator.vue?vue&type=script&lang=js&"
export * from "./Elevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b417c20",
  null
  
)

export default component.exports